import { useState } from 'react'

import SaveService from 'services/save.service'

import FloatingToolbar from 'components/elements/FloatingToolbar'

import { useActionless, useAppSelector } from 'app-redux/hooks'
import { useCanEditDeck } from 'app-redux/deck/selectors'

import MobileQuickAdd from 'components/deckPage/filtersAndControls/MobileQuickAdd'
import MobileLayoutControls from 'components/deckPage/filtersAndControls/MobileLayoutControls'
import MobileDeckMoreMenu from 'components/deckPage/filtersAndControls/MobileDeckMoreMenu'
import SaveWatcher from 'components/deckPage/DeckContainerV2/SaveWatcher'
import Icon from 'components/elements/Icon'
import DrawerMenu from 'components/elements/DrawerMenu'

import { SET_ACTIVE_STATE, TOGGLE_MODAL } from 'app-redux/active/actions/types'

import styles from './mobileToolbarV3.module.scss'

const MobileToolbarV3 = () => {
  const [quickAddOpen, setQuickAddOpen] = useState(false)
  const [layoutOpen, setLayoutOpen] = useState(false)
  const [moreMenuOpen, setMoreMenuOpen] = useState(false)

  const saving = useAppSelector(state => state.deck.saving)
  const undoStack = useAppSelector(state => state.deck.actionStack)

  const canEditDeck = useCanEditDeck()

  const [toggleModal, setActiveState] = useActionless(TOGGLE_MODAL, SET_ACTIVE_STATE)

  return (
    <>
      <FloatingToolbar
        gridColumns={5}
        options={[
          {
            icon: 'search',
            label: 'Search',
            onClick: () => setActiveState({ searchOpen: 'search' }),
            className: styles.newDeckIndicator,
          },

          {
            icon: 'add',
            label: 'Quick add',
            onClick: () => setQuickAddOpen(true),
            className: styles.newDeckIndicator,
            hidden: !canEditDeck,
          },
          {
            icon: 'copy outline',
            label: 'Clone',
            className: styles.newDeckIndicator,
            hidden: canEditDeck,
            onClick: () => toggleModal({ modalName: 'cloneModal', flag: true }),
          },

          {
            icon: 'sort content ascending',
            label: 'Layout',
            onClick: () => setLayoutOpen(true),
          },

          {
            icon: 'undo',
            label: 'Undo',
            disabled: !undoStack.length,
            onClick: () => SaveService.undo(),
            hidden: !canEditDeck,
          },
          {
            icon: 'comment outline',
            label: 'Comments',
            onClick: () => setActiveState({ interactionOverlay: true }),
            hidden: canEditDeck,
          },

          {
            iconElement: saving === 'saved' ? <Icon name="ellipsis horizontal" /> : <SaveWatcher />,
            label: saving === 'error' ? 'Unsaved' : saving === 'saving' ? 'Saving' : 'More',
            className: styles.newDeckIndicator,
            onClick: () => setMoreMenuOpen(true),
          },
        ]}
      />

      <DrawerMenu
        open={quickAddOpen}
        onClose={() => setQuickAddOpen(false)}
        minInitalOpenHeight={90}
        customOptionsTop={<MobileQuickAdd />}
      />

      <DrawerMenu
        open={layoutOpen}
        onClose={() => setLayoutOpen(false)}
        minInitalOpenHeight={50}
        customOptionsTop={<MobileLayoutControls />}
      />

      <DrawerMenu
        open={moreMenuOpen}
        onClose={() => setMoreMenuOpen(false)}
        maxInitialOpenHeight={70}
        customOptionsTop={<MobileDeckMoreMenu onClose={() => setMoreMenuOpen(false)} />}
      />
    </>
  )
}

export default MobileToolbarV3
